module.exports = __webpack_public_path__ + "static/media/basket-ball.4f932a5a.svg";